<script lang="ts">
  type Tab = {
    name: string;
    disabled?: boolean;
  };

  export let tabs: Tab[];
  export let active = 0;
</script>

<div class="tabs-container">
  <ul class="tabs" role="tablist">
    {#each tabs as tab, index (tab.name)}
      <li
        role="presentation"
        class="grow"
        class:active={active === index}
        on:click={() => {
          active = index;
        }}
      >
        <button class="tab" type="button" role="tab">
          {tab.name}
        </button>
      </li>
    {/each}
  </ul>

  <div class="w-full">
    <slot {active} />
  </div>
</div>

<style lang="postcss">
  .tabs-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .tabs {
    width: 100%;
    margin-bottom: 20px;
    background-color: var(--color-white);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    display: grid;
    gap: 5px;
    list-style: none;
    margin: 0;
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
  }

  .tab {
    border: 0;
    cursor: pointer;
    font-weight: 500;
    margin: 0;
    padding: 10px 15px;
    white-space: nowrap;
    width: 100%;
    border-radius: 8px;
  }

  .active {
    background-color: rgba(30, 151, 219, 0.1);
    color: #1e97db;
    cursor: default;
    border-radius: 8px;
  }
</style>
